export default __webpack_public_path__ + "static/young-toddler4-e77dd993aef1a50c50cce83fc3af8707.jpg";